import { Box } from "@chakra-ui/react";
import { ResponsiveImage } from "src/components/base/responsive-image";
import { IFeedCardImageBody } from "src/components/feed-card/types/content";

export const FeedCardImage = ({ url, alt }: IFeedCardImageBody) => (
    <Box>
        <ResponsiveImage baseUrl={url} alt={alt} />
    </Box>
);
